const Polynomial = require('mathFunctions/js/Polynomial').Polynomial;
const Constants = require('graph-netecs/js/Constants').Constants;
const Graph = require('graph-netecs/js/BarGraph/Graph').Graph;

class octaveGraphs {
    constructor(html, store, data) {
        if (html) {
            this.html = html;
            this.html.innerHTML = "";
        }
        this.store = store;
        this.data = data;

        /*
        NVS-29
        Wykresy oktawalne
        Korzystamy z wykresów słupkowych zdefiniowanych w bibliotece graph-netecs

        TŁUMACZENIA
            octave-graphs - Dane dotyczące hałasu wentylatora w punkcie pracy
            noise-inlet - Poziom ciśnienia akustycznego przy wolnym wlocie/wylocie (1m)
            noise-inlet-octave - Poziom ciśnienia akustycznego w oktawach przy wolnym wlocie/wylocie (1m)
            noise-housing - Poziom ciśnienia akustycznego obudowy (1m)*
            noise-housing-octave - Poziom ciśnienia akustycznego obudowy (1m) w oktawach
            noise-channel - Poziom siły dźwięku kanałów
            noise-channel-octave - Poziom siły dźwięku kanałów w oktawach

            oct - okt
            noise-tolerancy - Wartości hałasu +/- 5dB łącznie z silnikiem
            noise-octave-frequency - Częstotliwość oktawy

        Wszystko zależy od
        this.data.data.octave_graphs_enabled - 0 lub 1

        HAŁAS W PUNKCIE PRACY:
        this.data.params.noise
        */
        if (parseInt(this.data.data.octave_graphs_enabled)) {

            if (parseInt(this.data.data.octave_graphs_la56)) {
                let nc_a56_noises = this.calculateNoises('la56')
                if (nc_a56_noises.main != 0 && !isNaN(nc_a56_noises.main) && nc_a56_noises.main != Infinity) {
                    let graph_a56 = new Graph(nc_a56_noises.octaves, {
                        title: [
                            this.translate('noise-inlet'),
                            `L<sub>A6</sub>`,
                            `${nc_a56_noises.main} dB(A)`
                        ],
                        plane: {
                            height: 180
                        },
                        yLabel: [
                            this.translate('noise-inlet-octave'),
                            `L<sub>A6 ${this.translate('oct')}</sub>`,
                            `dB(A)`
                        ], 
                        xLabel: this.translate('noise-octave-frequency')
                    })
                    html.appendChild(graph_a56.html)
                }
            }

            if (parseInt(this.data.data.octave_graphs_lpa)) {
                let nc_pa_noises = this.calculateNoises('lpa')
                if (nc_pa_noises.main != 0 && !isNaN(nc_pa_noises.main) && nc_pa_noises.main != Infinity) {
                    let graph_pa = new Graph(nc_pa_noises.octaves, {
                        title: [
                            this.translate('noise-housing') + '*',
                            `L<sub>pA</sub>`,
                            `${nc_pa_noises.main} dB(A)`
                        ],
                        plane: {
                            height: 180
                        },
                        yLabel: [
                            this.translate('noise-housing-octave'),
                            `L<sub>pA ${this.translate('oct')}</sub>`,
                            `dB(A)`
                        ], 
                        xLabel: this.translate('noise-octave-frequency'),
                        legend: '* ' + this.translate('theoretical-noise-value') + ' ' + this.translate('engine-sound-value')
                    })
                    html.appendChild(graph_pa.html)
                }
            }

            if (parseInt(this.data.data.octave_graphs_lwa34)) {
                let nc_wa34_noises = this.calculateNoises('lwa34')
                if (nc_wa34_noises.main != 0 && !isNaN(nc_wa34_noises.main) && nc_wa34_noises.main != Infinity) {
                    let graph_wa34 = new Graph(nc_wa34_noises.octaves, {
                        title: [
                            this.translate('noise-channel') + '*',
                            `L<sub>WA3/4</sub>`,
                            `${nc_wa34_noises.main} dB(A)`
                        ],
                        plane: {
                            height: 180
                        },
                        yLabel: [
                            this.translate('noise-channel-octave'),
                            `L<sub>WA3/4 ${this.translate('oct')}</sub>`,
                            `dB(A)`
                        ], 
                        xLabel: this.translate('noise-octave-frequency'),
                        legend: '* ' + this.translate('theoretical-noise-value')
                    })
                    html.appendChild(graph_wa34.html)
                }
            }
        }
    }

    calculateNoises(type) {
        const engine_noise = this.data.engine.noise
        const ratedSpeed = ((this.store.state.workPointParameters.elements["work_frequency"].value / 50) * this.store.state.activeFun.data.avg_nominal_speed).toFixed(0);
        const totalPressure = this.store.state.workPointParameters.elements.total_pressure.value._oryginal
        const performance = this.store.state.workPointParameters.elements.performance.value / this.store.state.workPointParameters.elements.number_of_fans.value
        let ret = []
        let noise = 0

        if (type == 'la56') noise = Math.round(this.store.state.workPointParameters.elements.noise.value._oryginal)
        if (type == 'lpa') noise = Math.round(10 * Math.log10(Math.pow(10, (this.store.state.workPointParameters.elements.noise.value._oryginal - 9 * Math.log10(engine_noise)) / 10) + Math.pow(10, engine_noise / 10)))
        if (type == 'lwa34') noise = Math.round(9 * Math.log10(performance) + 20 * Math.log10(totalPressure) + 10 * Math.log10(ratedSpeed))

        for (const [key, value] of Object.entries(Object.entries(Object.entries(this.store.state.OctaveNoiseList).find(item => item[1].rpm == Math.ceil(ratedSpeed / 50) * 50))[1][1])) {
            if(key.startsWith('l_'))
                ret.push({ label: `${key.match(/\d+/)[0]} Hz`, value: noise - value })
        }
        
        return {octaves: ret, main: noise}
    }

    translate(code, displayErrors = true) {
        let arg = {
            type: 'translate',
            code: code,
            displayErrors: displayErrors,
            out: ""
        }

        this.store.commit(arg);

        return arg.out;
    }

    round(v, d) {
        return Math.round(v * Math.pow(10, d)) / Math.pow(10, d)
    }
}

export { octaveGraphs };
